export default __webpack_public_path__ + "static/media/icon_name.52cc4c55.svg";